import React, { useState, useEffect, useRef } from "react";

export const Navigation = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  // סגירה בלחיצה מחוץ לתפריט
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container" ref={menuRef}>
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle ${menuOpen ? "" : "collapsed"}`}
            onClick={toggleMenu}
            style={{ borderColor: "transparent" }}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            <span
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "-25px",
              }}
            >
              <img
                src="img/logos/rnetlogo192.png"
                alt="R&R-Net Logo"
                style={{ height: "70px", marginRight: "10px" }}
              />
              <span style={{ fontSize: "24px" }}>R & R - Net</span>
            </span>
          </a>
        </div>

        <div
          className={`collapse navbar-collapse ${menuOpen ? "in" : ""}`}
          id="bs-example-navbar-collapse-1"
          style={{
            maxHeight: menuOpen ? "500px" : "0",
            overflow: "hidden",
            transition: "max-height 0.35s ease-in-out",
          }}
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll" onClick={closeMenu}>
                Features
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll" onClick={closeMenu}>
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll" onClick={closeMenu}>
                Services
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll" onClick={closeMenu}>
                Gallery
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll" onClick={closeMenu}>
                Team
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={closeMenu}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
